// src/app/pipes/filter-statuses.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { OrderStatusResponse } from '../models/orders/order.model';

@Pipe({
  name: 'filterStatuses',
  standalone: true, // Generated as standalone
})
export class FilterStatusesPipe implements PipeTransform {

  transform(
    allStatuses: OrderStatusResponse[] | null,
    validTransitionIds: string[] | null | undefined
  ): OrderStatusResponse[] {

    // Basic checks for invalid inputs
    if (!allStatuses || allStatuses.length === 0) {
      // console.warn('FilterStatusesPipe: Received empty allStatuses array.');
      return [];
    }
    if (!validTransitionIds || validTransitionIds.length === 0) {
       return [];
    }

    // Create a Set for efficient lookup
    const validIdSet = new Set(validTransitionIds);

    // Filter the statuses
    const filtered = allStatuses.filter(status => validIdSet.has(status.id));
    // console.log('FilterStatusesPipe: Filtered statuses:', filtered); // Debug log
    return filtered;
  }
}